/**
 * @brief Mobile Navigation Bar 모바일 네비게이션 바 컴포넌트
 * @details
 * @author hyekyoungKang
 * @date 2024-06-10
 * @version 0.0.1
 */

import React, { useEffect, useRef, useState } from "react";
import styles from "./Mnb.module.scss";
import { Link, useNavigate } from "react-router-dom";
import CloseSvg from "./../../../assets/images/Close.svg";
import HamButtonSvg from "./../../../assets/images/HamButton.svg";
// import clsx from "clsx";

const Mnb = () => {
  const navigate = useNavigate(); // Initialize useNavigate
  const [isNavOpen, setIsNavOpen] = useState(false);
  const menuRef = useRef(null); // Ref for the menu container

  const NAV_ARRAY = [
    { name: "공간안내", link: "/spaceguide" },
    { name: "멤버쉽", link: "/membership" },
    {
      name: "방문 예약",
      link: "/contact",
    },
  ];

  const handleCloseMenu = () => {
    setIsNavOpen(false); // Close the menu
  };

  const handleNavigation = (link, name) => {
    navigate(link, { state: { title: name } });
    handleCloseMenu();
  };

  const handleClickOutside = (event) => {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      handleCloseMenu();
    }
  };

  // 외부 클릭 감지
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className={styles.container}>
      <div
        className={styles.menuButton}
        onClick={() => {
          setIsNavOpen(!isNavOpen);
          // console.log("메뉴클릭");
        }}
      >
        {isNavOpen ? (
          <CloseSvg width="28" height="28" fill="#555a5f" />
        ) : (
          <HamButtonSvg width="28" height="28" fill=" #555a5f" />
        )}
      </div>
      {isNavOpen && (
        <div ref={menuRef} className={styles.menuBox}>
          <ul className={styles.menuBox__menu}>
            {NAV_ARRAY.map((item) => {
              return (
                <Link
                  to={item.link}
                  key={item.name}
                  onClick={(e) => {
                    e.preventDefault(); // Prevent default behavior
                    handleNavigation(item.link, item.name);
                    console.log("클릭");
                  }}
                >
                  <li className={styles.menuBox__menuItem}>{item.name}</li>
                </Link>
              );
            })}
          </ul>
        </div>
      )}
    </div>
  );
};

export default Mnb;
